import React, { useEffect } from "react";
import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import CV from '../../assets/Resume/Merajul_CV.pdf';
import "./AboutMe.css";

export default function AboutMe(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  const fadeInSubscription =
    ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const SCREEN_CONSTSANTS = {
    description:
      "My name is H.M Merajul Hasan.I have completed my BSc degree in Computer Science & Engineering(in 2022) additionally, i have also completed my full stack web development course in 'Programming Hero' which is one of the best as well as well organized full stack Web Development institution in Bangladesh.Here i have learned dept knowledge and gathered skill in complete Web development  with background knowledge of MERN stack also. Passionate Front-End and MERN Stack web developer with extensive knowledge and ability to build innovative, creative, & interactive web-based applications using modern technology. Strong skills to write clean, efficient, and  reusable code for future use. Continue learning the latest technology and continue challenging myself.",
    highlights: {
      bullets: [
        "Responsive Web Layout(HTML5,CSS3,Flex,Grid,Media Query)",
        "CSS Frame Work(Bootstap 5,Tailwind CSS, Fontawesome)",
        "Integrate Javascript(DOM,Event listener,Interactive website)",
        "Intermediate Javascript,Building REST API(Dynamic Website,API,JSON,Fetch Data)",
        "Explore Browser & Debug (Browser API,DevTool,Debug,TypeScript)",
        "ReactJS Intro (React core concepts,State,props,SPA)",
        "React Router and States (React Router V6, material UI,Axios,Context API)",
        "React Authentication (Firebase,Google Login,Facebook Login,Git Hub Login etc)",
        "Intermediate level React (Redux core concepts,NextJS,React Native)",
        "Backend and Database Integration (Node,Express,MongoDB,CRUD operation,Heroku)",
        "Also,Secure API using JWT,Pagination,Dashboard,Admin role,payment Gateway",
        "Furthermore, i also learned Data Structure and Simple Algorithm"
      ],
      heading: "Here are a Few Highlights of What i have learned in this entire course:",
    },
  };
  const renderHighlight = () => {
    return SCREEN_CONSTSANTS.highlights.bullets.map((value, i) => (
      <div className="highlight" key={i}>
        <div className="highlight-blob"></div>
        <span>{value}</span>
      </div>
    ));
  };

  return (
    <div
      className="about-me-container screen-container fade-in"
      id={props.id || ""}
    >
      <div className="about-me-parent">
        <ScreenHeading title={"About Me"} subHeading={"Why Choose Me?"} />
        <div className="about-me-card">
          <div className="about-me-profile"></div>
          <div className="about-me-details">
            <span className="about-me-description">
              {SCREEN_CONSTSANTS.description}
            </span>
            <div className="about-me-highlights">
              <div className="highlight-heading">
                <span>{SCREEN_CONSTSANTS.highlights.heading}</span>
              </div>
              {renderHighlight()}
            </div>
            <div className="about-me-options">
              <button
                className="btn primary-btn" style={{backgroundColor:"coral"}}
                onClick={() => ScrollService.scrollHandler.scrollToHireMe()}
              >
                {" "}
                Hire Me{" "}
              </button>
              <a href={CV} download="Merajul_CV.pdf" style={{color:'purple'}}>
                <button className="btn highlighted-btn">Get My_CV</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
